
export enum PropertyType
{
    Room = 0,
    RoomContent = 1,
}